export const ActivityUploadStatuses = {
  PENDING_ZIP_UPLOAD: {
    name: "PENDING_ZIP_UPLOAD",
    displayName: "Pending",
    description: "The zip file is pending upload.",
  },
  UPLOADED_ZIP: {
    name: "UPLOADED_ZIP",
    displayName: "Processing",
    description:
      "The zip file has been uploaded. It will be processed shortly.",
  },
  PROCESSING_ZIP: {
    name: "PROCESSING_ZIP",
    displayName: "Processing",
    description: "The zip file is being processed.",
  },
  COMPLETED_UNZIP: {
    name: "COMPLETED_UNZIP",
    displayName: "Completed",
    description: "The zip file has been processed.",
  },
  FAILED_ZIP_UPLOAD: {
    name: "FAILED_ZIP_UPLOAD",
    displayName: "Failed",
    description: "The zip file upload failed.",
  },
  FAILED_UNZIP_PROCESSING: {
    name: "FAILED_UNZIP_PROCESSING",
    displayName: "Failed",
    description: "The zip file processing failed.",
  },
};

const statusesMap = new Map();
statusesMap.set(ActivityUploadStatuses.PENDING_ZIP_UPLOAD.name, ActivityUploadStatuses.PENDING_ZIP_UPLOAD);
statusesMap.set(ActivityUploadStatuses.UPLOADED_ZIP.name, ActivityUploadStatuses.UPLOADED_ZIP);
statusesMap.set(ActivityUploadStatuses.PROCESSING_ZIP.name, ActivityUploadStatuses.PROCESSING_ZIP);
statusesMap.set(ActivityUploadStatuses.COMPLETED_UNZIP.name, ActivityUploadStatuses.COMPLETED_UNZIP);
statusesMap.set(ActivityUploadStatuses.FAILED_ZIP_UPLOAD.name, ActivityUploadStatuses.FAILED_ZIP_UPLOAD);
statusesMap.set(ActivityUploadStatuses.FAILED_UNZIP_PROCESSING.name, ActivityUploadStatuses.FAILED_UNZIP_PROCESSING);

export function getActivityUploadStatus(statusName) {
    return statusesMap.get(statusName) ?? {};
}

export function getActivityUploadStatusDisplayName(statusName) {
    return statusesMap.get(statusName)?.displayName ?? "Unknown";
}

export function getActivityUploadStatusDescription(statusName) {
    return statusesMap.get(statusName)?.description ?? "Status is not available.";
}
